<template>
  <v-card tile class="ma-0 pa-0 card-shadow">
    <v-subheader class="subtitle-1 primary">
      <div class="white--text">
        <label class="font-weight-medium ma-0 pa-0">Team Ratings</label>
      </div>
    </v-subheader>
    <v-divider></v-divider>
    <!-- <div>{{current_applicant.team_ratings.length}}</div> -->
    <v-card-text
      class="overflow-y-auto"
      style="max-height:232px"
      v-if="
        current_applicant.specificSelectorExists &&
          current_applicant.team_ratings.length > 1
      "
    >
      <v-expansion-panels class="ma-0 pa-1 body-2 mb-4">
        <v-expansion-panel
          v-for="(rating, i) in current_applicant.team_ratings"
          :key="i"
          dense
        >
          <div v-if="rating._id != current_applicant.specificSelectorRatingId">
            <v-expansion-panel-header v-if="rating.selectorInfo != undefined">{{
              rating.selectorInfo.email
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="d-flex flex-column">
                <div class="d-flex flex-row justify-space-between">
                  <div class="body-2 ma-0 pa-0 d-flex align-center">
                    Academic Record
                  </div>
                  <div class="d-flex flex-row align-center justify-center">
                    <v-rating
                      class="hidden-sm-and-down"
                      readonly
                      background-color="primary"
                      color="primary"
                      dense
                      :value="rating.academicRating"
                      :length="6"
                    ></v-rating>
                    <span>({{ rating.academicRating }}/6)</span>
                  </div>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <div class="body-2 ma-0 pa-0 d-flex align-center">
                    Experience
                  </div>
                  <div class="d-flex flex-row align-center justify-center">
                    <v-rating
                      class="hidden-sm-and-down"
                      readonly
                      background-color="primary"
                      color="primary"
                      dense
                      :value="rating.experienceRating"
                      :length="5"
                    ></v-rating>
                    <span>({{ rating.experienceRating }}/5)</span>
                  </div>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <div class="body-2 ma-0 pa-0 d-flex align-center">
                    Overall Rating
                  </div>
                  <div class="d-flex flex-row align-center justify-center">
                    <v-rating
                      class="hidden-sm-and-down"
                      readonly
                      background-color="primary"
                      color="primary"
                      dense
                      :value="rating.overallRating"
                      :length="4"
                    ></v-rating>
                    <span>({{ rating.overallRating }}/4)</span>
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </div>
        </v-expansion-panel>
        <!-- <v-expansion-panel dense disabled v-else>
                      <v-expansion-panel-header>MY RATINGS</v-expansion-panel-header>
                    </v-expansion-panel>-->
      </v-expansion-panels>
    </v-card-text>
    <v-card-text v-else-if="!current_applicant.specificSelectorExists">
      <div v-if="current_applicant.team_ratings.length > 0">
        <div v-if="current_applicant.team_ratings.selectorInfo != undefined">
          <span
            v-for="(selector, index) in current_applicant.team_ratings"
            :key="index"
            >{{ selector.selectorInfo.email }},</span
          >
          <span v-if="current_applicant.name != undefined"
            >have rated {{ current_applicant.name }}.</span
          >
        </div>
        <div v-else>
          <label class="mt-2 body-1">
            Other selectors' ratings will be available here after you rate this
            applicant.
          </label>
        </div>
      </div>

      <div v-else>
        <label class="mt-2 body-1">
          No one has rated {{ current_applicant.name }}. Be the first one.
        </label>
      </div>
    </v-card-text>
    <!-- Is this working? -->
    <!-- <v-card-text v-else-if="current_applicant.team_ratings.length == 1">
                  <p
                    class="mt-2 body-1"
                  >You are the only one who has rated {{current_applicant.name}}.</p>
                </v-card-text>-->
  </v-card>
</template>

<script>
export default {
  name: 'TeamRatings',
  props: {
    current_applicant: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.team-rating-header-container {
  color: white;
}

.card-shadow {
  box-shadow: 0px 0px 75px #00000024 !important;
}
</style>
